<template>
    <div class="note-page v3">
        <om-loading
            v-if="isNotePageLoading"
            :visable="isNotePageLoading"
            type="whole"
            theme="blue"
        />
        <mui-errorloading v-else-if="isNotePageError"/>
        <div v-else class="note-page-container">
            <div class="note-title">
            </div>
            <div class="note-list">
                <note-item
                    v-for="(item,index) in noteList"
                    :key="index"
                    :note="item"
                />
                <div v-if="isShowNoData" class="no-list-toast">
                    还没有错题哦!
                    <span class="link-to-main" @click="goMain">返回首页</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NoteItem from './components/NoteItem.vue';
import {mapState, mapActions} from 'vuex';
import StatisticConst from '../../constant/StatisticConst';
import {closeNativePage} from '@/pages/pano-game/constant/JumpFunc';
export default {
    data() {
        return {
            isNotePageLoading: true,
            isNotePageError: false,
            isShowNoData: false
        };
    },
    components: {
        NoteItem
    },
    computed: {
        ...mapState('note', ['noteList'])
    },
    created() {
        StatisticConst.noteShow();
        this.initPage();
    },
    methods: {
        ...mapActions('note', ['getNoteList']),
        initPage() {
            this.getNoteList().then(res => {
                if (res && res.errno === 0 && res.data) {
                    this.isNotePageError = false;
                    this.isNotePageLoading = false;
                    if (this.noteList.length === 0) {
                        this.isShowNoData = true;
                    }
                }
            }).catch(() => {
                this.isNotePageError = true;
                this.isNotePageLoading = false;
            });
        },
        goMain() {
            closeNativePage();
        }
    }
};
</script>
<style lang='scss' src="./Note.scss"/>

